import React from "react";
import Parser from "html-react-parser";
import AdditionalInformationModal from "./AdditionalInformationModal";
import {
  Wrapper,
  Title,
  Body,
  ReadMore,
  ReadMoreButton,
} from "./styles/box-styles";
import { useModal } from "../../hooks";
import Candidate from "../../apiResources/Candidate";

export const AdditionalInformation = (props: Props) => {
  const { candidate } = props;
  const modal = useModal(false);

  return (
    <>
      <Wrapper className="animated delay-4 fadeIn" additionalInfo>
        <Title>Additional Information</Title>
        {candidate.additionalInfo ? (
          <Body additionalInfo>
            <div>{Parser(candidate.additionalInfo)}</div>
            {candidate.additionalInfo.length > 300 && (
              <ReadMore>
                <ReadMoreButton onClick={modal.open}>read more</ReadMoreButton>
              </ReadMore>
            )}
          </Body>
        ) : (
          <Body additionalInfo noData>
            no data
          </Body>
        )}
      </Wrapper>
      {modal.isOpen && (
        <AdditionalInformationModal
          candidate={candidate}
          onDismiss={modal.close}
        />
      )}
    </>
  );
};

type Props = {
  candidate: Candidate;
};

export default AdditionalInformation;
